import { useState } from "react";
import "./skills.scss";

export default function Skills() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    {
      id: "1",
      icon: "./assets/mobile.png",
      title: "Front-End Development",
      desc:
        "Skilled in HTML,CSS,JS and familiar with frameworks like React,BootStrap and TailWind",
      img:
      "assets/skill1.png",
    },
    {
      id: "2",
      icon: "./assets/globe.png",
      title: "Backend Development",
      desc:
        "Familiar with NodeJS,MongoDB,PHP and Firebase",
      img:
        "assets/skill_3.jpg",
    },
    {
      id: "3",
      icon: "./assets/writing.png",
      title: "Programming in C++",
      desc:
        "Proficient in C/C++",
      img:
        "assets/skill3.png",
    },
  ];

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 2)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
  };
  
  return (
    <div className="skills" id="skills">
      <div
        className="slider"
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {data.map((d) => (
          <div className="container">
            <div className="item">
              <div className="left">
                <div className="leftContainer">
                  <div className="imgContainer">
                    <img src={d.icon} alt="" />
                  </div>
                  <h2>{d.title}</h2>
                  <p>{d.desc}</p>
                  
                </div>
              </div>
              <div className="right">
                <img
                  src={d.img}
                  alt=""
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <img
        src="assets/arrow.png"
        className="arrow left"
        alt=""
        onClick={() => handleClick("left")}
      />
      <img
        src="assets/arrow.png"
        className="arrow right"
        alt=""
        onClick={() => handleClick()}
      />
    </div>
  );
}
